## 사이드 프로젝트


> 새로운 기술이 있다면 사이드프로젝트를 통해 먼저 실무에 적용 가능한지 테스트 해 보는것을 좋아합니다.<br/>
> 아래의 프로젝트들은 실제 서비스를 하거나 할 예정인 프로젝트들이며, 이외에도 개인적으로 불편함이 있다면 개발로 풀어나가는 것을 즐깁니다.

### Fleetia

- <small>현재</small>
    - 크롬 확장 프로그램 제작 프로젝트.
    - 일상 생활에서 사용 중 불편한 부분을 개발을 통해 해결하는것을 목표로 함.
    - 현재 새 탭 북마크 프로그램 개발 중
        - [https://github.com/fleetia/sherwood](https://github.com/fleetia/sherwood)
    - 사용기술
        - reactjs, vite


### AOU
- <small>2022.01-2022.04</small>
    - 트위터를 이용한 trpg게임 보조용 사이트
    - 비용 이슈로 백엔드는 heroku 및 lambda를 사용, DB를 스프레드시트로 사용함.
    - 캐릭터 스테이터스 및 레벨업, 상점 및 퀘스트 시스템 구현.
    - 운영 이후 폐쇄.
    - 사용기술
        - Frontend : Reactjs, recoil
        - Backend : nodejs, fastify
        - infrastructure : heroku, aws s3, cloudfront, route 53, lambda
        - db : google spreadsheet
        - CI/CD : github actions


### 글리터 <br/>
- <small>2021.07-2021.11</small>
    - 특정 주제로 짧은 글을 써서 공유하는 글쓰기 플랫폼
    - 디자이너 및 백엔드 개발자가 별도로 있었던 유일한 프로젝트로, 사용자가 없어 1개월 뒤 폐쇄.
    - 사용기술
        - Reactjs, recoil

### 문송한 사람들 <br/>
- <small>2021.02</small>
  - 카페24 기반 플리마켓 사이트. 쇼핑몰 디자인 마크업 및 플리마켓 운영에 필요한 프로그램 개발.
  - 플리마켓 운영 이후 폐쇄.
  - 사용기술
    - cafe24 solution, js

### 글록시니아<br/>
- <small>2013-2014</small>
  - [여성을 위한 연애시뮬레이션 게임](http://biz.heraldcorp.com/view.php?ud=20130426000133)
  - 비주얼노벨 게임 개발
  - 게임 시나리오 입력을 위한 엑셀 입력 툴 개발
  - 사용기술
    - python, ren’py, VBA